
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mtn-digital-services",
      function () {
        return require("private-next-pages/mtn-digital-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mtn-digital-services"])
      });
    }
  